// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Prhgl","colMin":"styles_colMin__29_Lb","colCheckbox":"styles_colCheckbox__2kPP8"};